import api from 'api/apiInstance';

export function googleAuthenticatorAPI(path: string) {
  return {
    path,
    generateQR: () => api.get(`${path}/setup_google_authenticator`),
    verify: (otpCode: string, currentPassword: string) =>
      api.post(`${path}/verify_google_authenticator_setup`, {
        data: {
          attributes: {
            otp_code: otpCode,
            current_password: currentPassword,
          },
        },
      }),
    disable: (currentPassword: string) =>
      api.patch(`${path}/disable_google_authenticator_setup`, {
        data: { attributes: { current_password: currentPassword } },
      }),
  };
}
